import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { useLocation } from '@gatsbyjs/reach-router'
import useMediaQuery from '@mui/material/useMediaQuery'
import PropTypes from 'prop-types'

import { USER_EXPERIENCES } from '../constants'
import { useAuth } from './AuthContext'

const ContactUsCollapseContext = createContext()

const useContactUsCollapseContext = () => {
  const context = useContext(ContactUsCollapseContext)
  if (!context) {
    return [false, () => {}]
  }
  return context
}

const ContactUsCollapseContexProvider = ({ children }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('lg'))
  const [isCollapsed, setIsCollapsed] = useState(true)
  const { pathname } = useLocation()
  const { access } = useAuth()
  const currentUserExperience = access?.isInstitutional ? USER_EXPERIENCES.INSTITUTIONAL_ONLY : USER_EXPERIENCES.UNATTESTED

  useEffect(() => {
    if (
      isMobile ||
      currentUserExperience === USER_EXPERIENCES.INSTITUTIONAL_ONLY
    ) {
      setIsCollapsed(true)
      if (typeof window !== 'undefined') {
        window.sessionStorage.setItem('contactUsCollapse', true)
      }
    } else if (typeof window !== 'undefined') {
      const sessionStorageIsCollapsed =
        window.sessionStorage.getItem('contactUsCollapse')

      if (sessionStorageIsCollapsed) {
        setIsCollapsed(sessionStorageIsCollapsed === 'true')
      }
    }
  }, [isMobile, currentUserExperience, pathname])

  const handleSetIsCollapsed = React.useCallback(() => {
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem('contactUsCollapse', !isCollapsed)
    }

    setIsCollapsed((prev) => !prev)
  }, [isCollapsed])

  const contextValue = useMemo(
    () => [isCollapsed, handleSetIsCollapsed],
    [isCollapsed, handleSetIsCollapsed]
  )

  return (
    <ContactUsCollapseContext.Provider value={contextValue}>
      {children}
    </ContactUsCollapseContext.Provider>
  )
}

ContactUsCollapseContexProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export {
  ContactUsCollapseContext,
  useContactUsCollapseContext,
  ContactUsCollapseContexProvider,
}
